export const PortInConfiguration = {
  excelTemplateTimeFormat: "hh:mm:ss A"
};
